import {
  Box,
  type BoxProps,
  Stack,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { AlertStatusEnum } from "~/feature/event/components/AlertSection/types";

export const Root = styled(Box)<BoxProps & { $status: AlertStatusEnum }>(
  ({ theme, $status }) => ({
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "flex-start",
    width: "100%",
    maxWidth: "100%",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${
      $status === AlertStatusEnum.UnifiedResolution
        ? theme.palette.success.main
        : theme.palette.error.main
    }`,
    backgroundColor:
      $status === AlertStatusEnum.UnifiedResolution
        ? alpha(theme.palette.success.main, 0.12)
        : alpha(theme.palette.error.main, 0.12),
  })
);

export const Header = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(2),
}));
export const RulesWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const SectionTitle = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  })
);

export const AlertSubtitle = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    color: theme.palette.text.primary,
  })
);

export const RuleBlock = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

export const RuleTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
  display: "inline",
  color: theme.palette.text.primary,
  fontSize: theme.typography.caption.fontSize,
  lineHeight: theme.typography.caption.lineHeight,
  letterSpacing: theme.typography.caption.letterSpacing,
  fontWeight: 700,
}));

export const RuleList = styled("ul")(({ theme }) => ({
  paddingLeft: theme.spacing(2.5),
  margin: 0,
  listStyleType: "disc",
}));
